import { dataSettingsSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSettingsSolid = /*#__PURE__*/createIcon(dataSettingsSolid)
export default IconSettingsSolid
